// 数据打点 key:id
const eventkeys = {
  // 登录应用(1000)
  click_icon: "10000001", // 启动应用/进入站点
  login_page: "10000002", // 进入登录界面
  login_click: "10000003", // 点击登录
  login_click_success: "10000004", // 登录成功
  web_homeload_success: "10000010", // web首页模版加载完成
  web_resource_success: "10000011", // web页面资源渲染成功
  // 登录账号
  login_close: "10000013", // 登录_关闭
  login_forgot_password: "10000014", // 登录_忘记密码
  login_switch_register: "10000015", // 登录_切换注册
  exposure: "99000001", // 曝光
  click: "99000002", // 曝光点击
  heart_beat: "20010001", // 心跳
  // 注册账号（1001）
  click_register: "10010001", // 进入注册界面
  register: "10010002", // 注册
  register_success: "10010003", // 注册成功
  register_page_close: "10010008", // 注册页_关闭
  register_page_input_password: "10010009", // 注册页_输入密码
  register_page_switch_login: "10010010", // 注册页_切换登录
  // 游戏大厅(1002)
  click_gameicon: "10020002", // 点击游戏（gameid)
  get_gameurl_success: "10020003", // 获取游戏url成功
  click_menu_first: "10020004", // 一级菜单
  click_menu_second: "10020005", // 二级菜单
  click_navigation: "10020006", // 导航栏
  rotation_chart: "10020007", // 轮播图 enum:轮播图枚举
  customer_service: "10020011", // 在线客服
  floating_window_click: "10020014", // 浮窗点击
  customer_service_click: "10020015", // 客服入口点击
  // 充值(1003)
  click_charge: "10030001", // 点击充值
  close_charge_page: "10030002", // 关闭充值页面
  charge_confirm: "10030003", // 充值确定
  charge_order: "10030004", // 打开三方充值订单
  charge_close_three: "10030005", // 关闭三方充值
  charge_model: "10030006", // 快捷充值金额选择
  charge_select_currency: "10030007", // 充值选择币种
  select_payment_method: "10030008", // 选择支付方式
  select_event_benefits: "10030009", // 活动优惠选择
  charge_event_details: "10030010", // 活动详情
  charge_order_close: "10030011", // 充值订单关闭按钮
  charge_log: "10030012", // 充值日志
  recharge_page_related_click: "10030013", // 充值页面关联功能点击
  select_event_close: "10030014", // 活动优惠关闭
  charge_currency: "10030015", // 充值_切换货币 SubChargeCurrency
  recharge_cashier_popup_show: "10030016", // 充值_充值收银台弹窗_弹出
  recharge_cashier_popup_payclick: "10030017", // 充值_充值收银台弹窗_点击支付 Subpayclick
  charge_order_interface: "10030021", // 存款订单界面SubChargeThree	Return  ContinuePay
  recharge_cashier_popup_copylink: "10030022", // 复制链接
  recharge_cashier_nativepay_open: "10030023", // 打开原生支付界面、
  recharge_cashier_nativepay_destroy: "10030024", // 销毁原生支付界面
  recharge_cashier_nativepay_fetch_fail: "10030025", // 原生界面拉取失败
  // 提现(1004)
  click_exchange: "10040001", // 点击取款
  close_exchange_page: "10040002", // 关闭取款页面
  click_exchange_page: "10040003", // 点击取款页面取款
  submit_application: "10040004", // 提交申请
  excharge_select_currency: "10040005", // 取款选择币种
  exchange_info: "10040006", // 绑定账户
  exchange_info_type: "10040007", // 添加账户
  exchange_info_save: "10040008", // 账户信息保存
  exchange_id: "10040009", // 选择快捷提现金额
  exchange_type: "10040010", // 选择账号类型
  exchange_order_record: "10040011", // 提现记录
  exchange_order_detail: "10040012", // 订单详情
  // 活动(1005)
  events_id: "10050001", // 活动标签
  events_go: "10050002", // 活动id【前往】
  events_conditional_popup_giveup: "10050004", // 活动_条件弹窗_放弃按钮
  events_conditional_popup_join: "10050005", // 活动_条件弹窗_参与按钮
  events_conditional_popup_close: "10060006", // 活动_条件弹窗_关闭
  // 好友邀请（1006)
  copy_invite_url: "10060001", // 复制邀请链接
  copy_invite: "10060002", // 复制邀请码
  // app下载（1007)
  download_ios: "10070001", // ios下载
  download_android: "10070002", // android下载
  enter_web: "10070003", // 进入官网下载页
  // 错误日志上报（1008）
  err_log: "10080001",
  timeout_log_web: "1008000111", // 请求超时30000
  white_screen: "1008000112", // 白屏无标签渲染
  click_menu: "10090001", // H5底部tab 点击菜单
  click_activity: "10090002", // H5底部tab 点击活动
  click_home: "10090003", // H5底部tab 点击首页
  click_invite: "10090004", // H5底部tab 点击邀请
  click_account: "10090005", // H5底部tab 点击账户
  // 奥运主界面弹出
  eject_olympic_home: "10100001",
  // 点击竞猜展开详情 type: 奖牌类型
  click_guess: "10100003",
  // 奥运竞猜下注界面弹出
  // 1.增加奖牌类型type
  // 2.增加国家类型country
  // 3.增加入口类型entrance
  eject_bet: "10100004",
  click_bet_yes: "10100005", // 奥运竞猜下注界面点击yes
  click_bet_no: "10100006", // 奥运竞猜下注界面点击no
  click_bet_maximum: "10100007", // 奥运竞猜下注界面点击maximum
  click_bet_minus: "10100008", // 奥运竞猜下注界面点击减号
  click_bet_plus: "10100009", // 奥运竞猜下注界面点击加号
  click_bet_ok: "10100010", // 奥运竞猜下注界面点击投注 成功：参数num
  click_bet_close: "10100011", // 奥运竞猜下注界面点击关闭
  // 签到界面弹出
  eject_sign_home: "10110001",
  click_sign_day: "10110002", // 每日签到点击
  sign_day_success: "10110003", // 每日成功签到
  click_sign_accumulation: "10110004", // 累积签到点击
  sign_accumulation_success: "10110005", // 累积签到成功
  click_sign_help: "10110006", // 累积签到帮助点击
  click_sign_close: "10110007", // 累积签到关闭
  sign_week_buy: "10110008", // 签到_周卡_购买
  // 利息宝
  eject_interest_home: "10120001", // 利息宝界面弹出
  interest_in_click: "10120002", // 利息宝转入按钮点击
  interest_in_ok_click: "10120003", // 利息宝转入界面确定按钮点击
  interest_in_all_click: "10120004", // 利息宝转入界面全部按钮点击
  interest_in_close_click: "10120005", // 利息宝转入界面点击关闭
  interest_in_success: "10120006", // 利息宝成功转入
  interest_out_click: "10120007", // 利息宝转出按钮点击
  interest_out_ok_click: "10120008", // 利息宝转出界面确定按钮点击
  interest_out_all_click: "10120009", // 利息宝转出界面全部按钮点击
  interest_out_close_click: "10120010", // 利息宝转出界面点击关闭
  interest_out_success: "10120011", // 利息宝成功转出
  interest_receive_click: "10120012", // 利息宝领取按钮点击
  interest_receive_success: "10120013", // 利息宝成功领取
  interest_record_click: "10120014", // 利息宝记录明细点击
  interest_recordtime_click: "10120015", // 利息宝记录时间类型查询
  interest_rull_click: "10120016", // 利息宝利息规则点击
  interest_close_click: "10120017", // 利息宝关闭按钮点击
  invite_table_in: "10130001", // 拉新助力街机抽奖弹出
  invite_table_click: "10130002", // 拉新助力（首次）街机点击抽奖
  invite_table_close: "10130003", // 拉新助力街机抽奖点击关闭
  invite_get_more: "10130004", // 拉新助力主界面弹出
  invite_website_copy: "10130010", // 拉新助力网址复制按钮点击
  invite_website_open: "10130011", // 拉新助力邀请链接打开
  invite_withdrawal_success: "10130017", // 拉新助力成功提现
  invite_float_initial_click: "10130018", // 拉新悬浮窗_点击
  // invite_float_assist_click: "10130019", // 拉新悬浮窗_助力状态_点击
  // invite_float_claim_click: "10130020", // 拉新悬浮窗_领取状态_点击
  // invite_float_withdraw: "10130021", // 拉新悬浮窗_领取提现
  invite_activity_details_click: "10130022", // 拉新活动_活动详情_点击
  invite_activity_rules_click: "10130023", // 拉新活动_玩法规则_点击
  invite_activity_accelerate_click: "10130024", // 拉新活动_加速提现_点击
  reward_popup_withdraw_click: "10130025", // 奖励弹窗_进行游戏_点击
  activity_details_share_accelerate: "10130026", // 活动详情页面_加速提现
  invite_popup_lottery_click: "10130027", // 拉新弹窗_抽奖按钮_点击
  activity_details_rank_daily: "10130028", // 活动详情_榜单_日榜
  activity_details_rank_total: "10130029", // 活动详情_榜单_总榜
  invite_share_telegram: "10130030", // 拉新_分享渠道
  invite_assist_record: "10130035", // 拉新_助力记录
  invite_sacar_click: "10130036", // 拉新_SACAR
  activity_details_share_accelerate_popup: "10130037", // 活动详情页面_加速提现_弹窗
  activity_details_share_accelerate_popup_close: "10130038", // 活动详情页面_加速提现_弹窗_关闭
  invite_website_popup_close: "10130039", // 拉新助力网址复制弹窗关闭
  tpgn_notice_pop: "10140001", // 图片功能公告弹框弹出 跳转功能jump_value（目前后台所有配置项，使用首字母拼音做参数）
  tpgn_notice_ok: "10140002", // 图片功能公告弹窗点击确认 跳转功能jump_value
  tpgn_notice_close: "10140003", // 图片功能公告弹窗点击关闭 跳转功能jump_value
  notice_popup_share: "10140004", // 公告弹窗_分享
  screen_slide_scale: "10150001", // 登录前玩家触发首页屏幕滑动 比例参数slide-value（滑动hd，滑动到底部hddb）
  h5_click_navigation: "10090001", // 点击H5底部导航
  bonus_page_bonus_click: "10160001", // 奖金页奖金页点击
  bonus_page_events_click: "10160002", // 奖金页活动页点击
  bonus_page_task_click: "10160003", // 奖金页任务页点击
  bonus_page_viewbutton_click: "10160004", // 奖金页查看按钮点击
  bonus_page_receivebutton_click: "10160005", // 奖金页领取按钮点击
  task_center_show: "10290001", // 任务中心展示 key：SubTask  Vlue：merge、separate
  task_center_gb: "10290002", // 任务中心关闭
  task_tab_click: "10160006", // 任务页导航按钮点击
  task_gobutton_click: "10160007", // 任务页前往按钮点击
  task_receivebutton_click: "10160008", // 任务页领取按钮点击,
  today_reward_tips_pop: "10170001", // 当日奖励引导弹框弹出
  today_reward_view_click: "10170002", // 当日奖励引导查看按钮点击
  tomorrow_reward_tips_pop: "10170003", // 明日奖励引导弹框弹出
  redenvelope_grab: "10180001", // 定时红包引导弹窗_立即去抢
  redenvelope_popup: "10180002", // 进入定时红包活动弹窗
  rain_envelopes: "10180003", // 进入定时红包红包雨
  rain_redenvelopes: "10180004", // 红包雨_点击红包
  rain_Settlement: "10180005", // 红包雨_活动结算页面
  rain_quit: "10180006", // 红包雨_退出
  timed_red_packet_unrecharged_popup_show: "10180007", // 定时红包未充值弹窗
  timed_red_packet_unrecharged_popup_get_qualified: "10180008", // 定时红包未充值弹窗_充值资格
  timed_red_packet_unrecharged_popup_close: "10180009", // 定时红包未充值弹窗_关闭
  timed_red_packet_retention_popup_show: "10180010", // 定时红包未挽回弹窗
  timed_red_packet_retention_popup_continue: "10180011", // 定时红包未挽回弹窗_继续参加
  timed_red_packet_retention_popup_close: "10180012", // 定时红包未挽回弹窗_关闭
  redpacket_rain_direct_claim_click: "10180013", // 红包雨_直接领取
  redpacket_rain_inflated_recharge: "10180014", // 红包雨_膨胀充值
  redenvelope_popup_close: "10180015", // 进入定时红包活动弹窗关闭
  restrict_withdrawal_open: "10040013", // 限制出款_打码引导弹窗弹出
  restrict_withdrawal_coding: "10040014", // 限制出款_打码引导弹窗_去打码
  restrict_withdrawal_three: "10040015", // 限制出款_打码引导弹窗_复制和点击三方分享
  card_web_pop: "10220001", // 周月卡_首页_弹出
  card_event_buy: "10220002", // 周月卡_购卡
  card_event_buy_success: "10220003", // 周月卡_购卡成功
  card_claim_details: "10220004", // 周月卡_领取详情
  card_buy_details: "10220005", // 周月卡_购买详情
  card_event_claim: "10220006", // 周月卡_领取奖励
  first_withdraw_progress_popup_show: "10230001", // 首提引导_提现进度弹窗展示 key：SubEvLocation Vlue：Enter、Return、Switch
  first_withdraw_progress_popup_play_now: "10230002", // 首提引导_提现进度弹窗_马上游戏
  first_withdraw_guide_popup_show: "10230003", // 首提引导_提现引导弹窗
  first_withdraw_guide_popup_withdraw_now: "10230004", // 首提引导_提现引导弹窗_立即提现
  first_withdraw_guide_popup_close: "10230036", // 首提引导_提现进度弹关闭
  err_log_getPacketDomain: "10080003", // getPacketDomain错误日志上报
  register_retention_popup_show: "10010005", // 注册页挽回展示
  register_retention_popup_confirm: "10010006", // 注册页挽回展示_确定
  register_retention_popup_cancel: "10010007", // 注册页挽回展示_取消
  featured_modules: "10020019", // 特色模块
  lucky_game: "10020016", // 幸运游戏
  new_recharge: "10020017", // 新人充值
  download_template: "10020018", // 下载模板
  first_recharge_popup_show: "10230005", // 首充弹窗
  first_recharge_popup_recharge_now: "10230006", // 首充弹窗_立即充值
  repeat_recharge_popup_show: "10230007", // 复充弹窗
  repeat_recharge_popup_recharge_now: "10230008", // 复充弹窗_立即充值
  bankruptcy_popup_show: "10230009", // 破产弹窗
  bankruptcy_popup_join_now: "10230010", // 破产弹窗_立即参与
  betting_rank_exchange_click: "10240001", // 打码排行榜_兑换
  betting_rank_more_click: "10240002", // 打码排行榜_更多
  betting_rank_exchange_claim: "10240003", // 打码排行榜_兑换_领取
  Click_mailbox: "10260001", // 点击邮箱
  Center_Receive: "10260002", // 邮箱中心_领取
  Center_JumpButton: "10260003", // 邮箱中心_跳转按钮
  Center_Delete: "10260004", // 邮箱中心_删除
  Desktop_Click: "10270001", // 桌面快捷方式点击
  Desktop_Close: "10270002", // 桌面快捷方式关闭
  Desktop_popup_close: "10270003", // 桌面快捷方式_弹窗_关闭
  Desktop_popup_cancel: "10270004", // 桌面快捷方式_弹窗_取消
  // 集卡得好礼（1019）
  jiaka_newuser_guide_popup: "10190001", // 集卡_新人引导_弹出
  jiaka_home_popup: "10190002", // 集卡_首页_弹出
  jiaka_home_draw: "10190003", // 集卡_首页_抽卡
  jiaka_home_invite_friend: "10190004", // 集卡_首页_邀请好友
  jiaka_home_receive_card: "10190005", // 集卡_首页_领卡
  jiaka_task_receive: "10190006", // 集卡_任务_领取
  jiaka_exchange: "10190007", // 集卡_兑换
  // 神秘奖励（1020）
  mystery_home_popup: "10200001", // 神秘_首页_弹出
  mystery_open_treasure: "10200002", // 神秘_开宝箱
  mystery_tips: "10200003", // 神秘_温馨提示
  mystery_recharge_now: "10200004", // 神秘_立即充值
  mystery_inflated_chest_recharge: "10200005", // 神秘_膨胀宝箱充值
  mystery_recharge_popup: "10200006", // 神秘_膨胀宝箱弹出
  mystery_inflated_chest_close: "10200007", // 神秘_膨胀宝箱关闭
  mystery_retain_recharge: "10200008", // 神秘_挽留弹窗充值
  mystery_retain_popup: "10200009", // 神秘_挽留弹窗_弹出
  mystery_retain_close: "102000010", // 神秘_挽留弹窗关闭
  mystery_receive: "102000011", // 神秘_直接领取
  // 开服冲榜（1021）
  rank_home_popup: "10210001", // 冲榜_首页_弹出
  rank_view_details: "10210002", // 冲榜_了解详情
  rank_detail: "10210003", // 冲榜_冲榜详情
  rank_receive_reward: "10210004", // 冲榜_领取奖励
  reward_receive_double: "10210005", // 奖励领取_双倍领取
  double_receive_go_recharge: "10210006", // 双倍领取_去充值
  double_receive_direct: "10210007", // 双倍领取_直接领取
  // 打码排行榜（1024）
  dama_rank_popup: "10240004", // 打码排行榜展示
  grand_prize_popup: "10230012", // 大奖弹窗key：SubGrand Vlue：Register、recharge
  grand_prize_popup_confirm: "10230011", // 大奖弹窗_确认 key：SubGrandPrize Vlue：Register、recharge
  // 离线消息 1028
  // offline_msg_receive: "10280001", // 接受离线消息
  offline_msg_click: "10280002", // 点击离线消息  SubOffline  apk、pwa
  // 充值礼包
  recharge_gift_popup: "10230013", // 充值礼包_弹出
  recharge_gift_recharge: "10230014", // 充值礼包_充值
  recharge_gift_return_success: "10230016", // 充值礼包_返回成功
  recharge_gift_amount_switch: "10230015", // 充值礼包_金额切换
  recharge_gift_close: "10230032", // 充值礼包_关闭
  grand_prize_popup_close: "10230017", // 大奖弹窗_关闭
  first_recharge_popup_close: "10230018", // 首充弹窗_关闭
  repeat_recharge_popup_close: "10230019", // 复充弹窗_关闭
  bankruptcy_popup_close: "10230020", // 破产弹窗_关闭
  game_hint_popup: "10230021", // 游戏提示用户弹窗弹出
  game_hint_popup_jump: "10230022", // 游戏提示用户弹窗弹出_跳转按钮
  game_hint_popup_close: "10230023", // 游戏提示用户弹窗弹出_关闭
  game_limit_popup: "10230024", // 游戏限制用户弹窗弹出
  game_limit_popup_jump: "10230025", // 游戏限制用户弹窗弹出_跳转按钮
  game_limit_popup_close: "10230026", // 游戏限制用户弹窗弹出_关闭
  // VIP中心
  vip_center_enter: "10300001", // VIP中心进入
  vip_center_rebate_activity_click: "10300002", // VIP中心_返利活动点击
  vip_center_upgrade_reward_receive: "10300003", // VIP中心_升级奖励_领取
  vip_center_week_receive: "10300004", // VIP中心_周_领取
  vip_center_month_receive: "10300005", // VIP中心_月_领取
  vip_center_withdraw_click: "10300006", // VIP中心_提现_点击
  vip_center_spin_click: "10300007", // VIP中心_旋转_点击
  vip_center_switch_vip_level: "10300008", // VIP中心_切换VIP等级
  vip_center_recharge_click: "10300009", // VIP中心_充值按钮_点击
  vip_center_invite_click: "10300010", // VIP中心_邀请按钮_点击
  // 返利活动
  rebate_activity_enter: "10310001", // 返利活动进入
  rebate_activity_receive: "10310002", // 返利活动_领取
  rebate_activity_switch_cycle: "10310003", // 返利活动_切换周期
  rebate_activity_switch_event: "10310004", // 返利活动_切换活动
  // 集字转盘活动
  collect_word_wheel_enter: "10330001", // 集字转盘进入
  collect_word_wheel_draw_day: "10330002", // 集字转盘_抽日
  collect_word_wheel_draw_week: "10330003", // 集字转盘_抽周
  collect_word_wheel_draw_month: "10330004", // 集字转盘_抽月
  collect_word_wheel_switch: "10330005", // 集字转盘_切换
  collect_word_wheel_exchange: "10330006", // 集字转盘_兑换
  // 分享赚钱
  share_earn_enter: "10340001", // 分享赚钱进入
  share_earn_total_box_activate: "10340002", // 分享赚钱_累计宝箱_激活
  share_earn_total_box_receive: "10340003", // 分享赚钱_累计宝箱_领取
  // 转盘充值活动
  spin_recharge_enter: "10350001", // 转盘充值进入
  spin_recharge_spin: "10350002", // 转盘充值_旋转
  spin_recharge_receive_reward: "10350003", // 转盘充值_领奖
  // 奖励列表弹窗
  reward_list_popup_enter: "10360001", // 奖励列表弹窗进入
  reward_list_popup_login: "10360002", // 奖励列表弹窗_登录
  reward_list_popup_share: "10360003", // 奖励列表弹窗_分享
  reward_list_popup_close: "10360004", // 奖励列表弹窗_关闭
  reward_list_popup_recharge: "10360005", // 奖励列表弹窗_充值
  reward_list_popup_bonus_page: "10360006", // 奖励列表弹窗_奖金页
  // 提现引导+vip限制
  withdraw_guide_contact_service: "10040013", // 提现引导_联系客服
  vip_limit_recharge: "10040014", // vip限制_充值
  vip_limit_contact_service: "10040015", // vip限制_联系客服
  vip_limit_close: "10040016", // vip限制_关闭
  vip_limit_withdraw_popup: "10040017", // vip限制提现弹窗弹出
  // 转盘活动
  wheel_activity_enter: "10320001", // 转盘活动进入
  wheel_activity_draw: "10320002", // 转盘活动_抽奖
  wheel_activity_draw_10x: "10320003", // 转盘活动_抽奖_10连抽
  wheel_activity_switch: "10320004", // 转盘活动_切换
  wheel_activity_reward_confirm: "10320005", // 转盘活动_奖励确认
  wheel_activity_upgrade_vip: "10320006", // 转盘活动_升级VIP
  wheel_activity_reward_confirm_close: "10320008", // 转盘活动_奖励确认_关闭
  wheel_activity_thank_confirm: "10320009", // 转盘活动_感谢_确认
  wheel_activity_thank_close: "10320010", // 转盘活动_感谢_关闭
  wheel_activity_allrecord_click: "10320011", // 转盘活动_全部记录_点击
  wheel_activity_allrecord_close: "10320012", // 转盘活动_全部记录_关闭
  wheel_activity_personalrecord_click: "10320013", // 转盘活动_个人记录_点击
  wheel_activity_personalrecord_close: "10320014", // 转盘活动_个人记录_关闭

  floating_window_click_close: "10020020", // 浮窗点击_关闭
  exchange_info_close: "10040018", // 关闭绑定账户
  events_details_go: "10050003", // 活动详情【前往】
  jiaka_close: "10190008", // 集卡_关闭
  jiaka_card_confirm: "10190009", // 集卡_卡片_确认按钮
  mystery_close: "10200012", // 神秘_关闭
  mystery_tips_close: "10200014", // 神秘_温馨提示_关闭
  rank_close: "10210008", // 冲榜_关闭
  card_event_close: "10220007", // 周月卡_关闭
  dama_rank_close: "10240005", // 打码排行榜关闭
  Center_close: "10260005", // 邮箱中心_关闭
  mail_center_enter: "10260006", // 邮箱中心打开
  Single_email_open: "10260007", // 单个邮件打开
  Center_Delete_confirm: "10260008", // 邮箱中心_删除_确认
  Center_Delete_cancel: "10260009", // 邮箱中心_删除_取消
  Center_Delete_close: "10260010", // 邮箱中心_删除_关闭
  rebate_activity_close: "10310005", // 返利活动_关闭
  rebate_activity_popup_claimmore: "10310006", // 返利活动_弹窗_获得更多
  rebate_activity_popup_receive: "10310007", // 返利活动_弹窗_领取
  rebate_activity_popup_close: "10310008", // 返利活动_弹窗_关闭
  wheel_activity_close: "10320007", // 转盘活动_关闭
  collect_word_wheel_close: "10330007", // 集字转盘_关闭
  share_earn_total_box_activate_share: "10340004", // 分享赚钱_累计宝箱_激活_分享
  share_earn_total_box_activate_close: "10340005", // 分享赚钱_累计宝箱_激活_关闭
  share_earn_receive: "10340006", // 分享赚钱_领取
  share_earn_history: "10340007", // 分享赚钱_历史
  share_earn_transfer: "10340008", // 分享赚钱_转存
  share_earn_withdraw: "10340009", // 分享赚钱_提现
  share_earn_tab_switch: "10340010", // 分享赚钱_Tab切换
  spin_recharge_close: "10350004", // 转盘充值_关闭
  // 17.0
  reward_arrival_popup: "10230027", // 奖励到账弹窗_弹出
  reward_arrival_popup_receive: "10230028", // 奖励到账弹窗_领取
  free_transfer_popup: "10230029", // 免费转到账弹窗_弹出x
  free_transfer_popup_receive: "10230030", // 免费转到账弹窗_领取x
  reward_popup_deposit: "10230031", // 奖励到账弹窗_充值
  reward_claim_popup_claim_click: "10230033", // 奖励领取_弹出
  reward_claim_popup_claim_click_gb: "10230034", // 奖励领取关闭_弹出
  reward_claim_popup_claim_click_lj: "10230035", // 奖励领取_领奖
  login_password_set_popup: "10040019", // 登录密码设置_弹出
  login_password_set_confirm: "10040020", // 登录密码设置_确定
  recharge_unlock_withdraw_notice_popup: "10040021", // 充值解锁提现通知界面_弹出
  recharge_unlock_withdraw_notice_deposit: "10040022", // 充值解锁提现通知界面_存款
  recharge_unlock_withdraw_notice_skip: "10040023", // 充值解锁提现通知界面_暂不操作
  recharge_unlock_withdraw_notice_close: "10040024", // 充值解锁提现通知界面_关闭
  // withdraw_recharge: "10040025", // 提现_充值
  free_coin_withdraw_popup: "10040026", // 免费金币提现界面_弹出
  free_coin_withdraw_do: "10040027", // 免费金币提现界面_提现
  free_coin_withdraw_fail_activate: "10040028", // 免费金币提现界面_提现失败激活
  free_coin_withdraw_switch_amount: "10040029", // 免费金币提现界面_切换金额

  // 游戏浮窗
  game_float_expand: "10380001", // 游戏浮窗_展开
  game_float_lobby: "10380002", // 游戏浮窗_大厅
  game_float_recharge: "10380003", // 游戏浮窗_充值
  game_float_task: "10380004", // 游戏浮窗_任务
  game_float_close: "10380005", // 游戏浮窗_关闭

  // 注册送金
  // register_bonus_popup: "10390001", // 注册送金界面_弹出
  // register_bonus_receive: "10390002", // 注册送金界面_领取
  // register_bonus_close: "10390003", // 注册送金界面_关闭
  register_success_popup: "10390004", // 注册成功_弹出
  register_success_pay: "10390005", // 注册成功_pay
  register_success_close: "10390006", // 注册成功_关闭
  register_success_spin: "10390007", // 注册送金_点击旋转
  register_success_reward: "10390008", // 注册送金_领取奖励

  // 反向引导
  home_free_coin_withdraw: "10400001", // 首页免费金币引导_提现
  currency_display_click: "10400002", // 货币展示_点击
  currency_display_cash_withdraw: "10400003", // 货币展示_现金提现
  currency_display_free_coin_withdraw: "10400004", // 货币展示_免费金币提现
  currency_commission_withdraw: "10400010", // 货币展示_佣金提现
  game_unlock_withdraw_click: "10400005", // 游戏_解锁提现点击
  game_unlock_withdraw_hint_popup: "10400006", // 游戏_解锁提现点击提示弹窗_弹出
  game_unlock_withdraw_hint_popup_jump: "10400007", // 游戏_解锁提现点击提示弹窗_跳转按钮
  game_unlock_withdraw_hint_popup_contact_service: "10400008", // 游戏_解锁提现点击提示弹窗_联系客服
  game_unlock_withdraw_hint_popup_close: "10400009", // 游戏_解锁提现点击提示弹窗_关闭
  H5_topnavigation_click: "10410001", // H5顶部引导_点击
  H5_topnavigation_close: "10410002", // H5顶部引导_关闭
  personal_center_deposit: "10420001", // 个人中心_存款
  personal_center_withdraw: "10420002", // 个人中心_提现
  personal_center_balance_details: "10420003", // 个人中心_余额详情
  personal_center_task: "10420004", // 个人中心_任务中心
  personal_center_progressbar_prompt: "10420005", // 个人中心_进度条_提示
  personal_center_VIP_details: "10420006", // 个人中心_VIP详情

  // 订单发起挽回
  order_retrieval_floating_payment: "10430001", // 订单发起挽回_悬浮窗_支付
  order_retrieval_popup_quit_discount: "10430002", // 订单发起挽回_弹窗_放弃优惠
  order_retrieval_popup_payment: "10430003", // 订单发起挽回_弹窗_支付
  order_retrieval_popup_close: "10430004", // 订单发起挽回_弹窗_关闭
  order_retrieval_popup: "10430005", // 订单发起挽回_弹窗_弹出
  order_retrieval_floating_popup: "10430006", // 订单发起挽回_悬浮窗_弹出
  hotgame_popup_show: "10440001", // 热门游戏_弹出
  hotgame_popup_close: "10440002", // 热门游戏_关闭

  personal_center_freebetting: "10420007", // 免费下注-进入
  freebetting_play: "10420008", // 免费下注-玩游戏

  // 修改账户
  exchange_info_edit: "10040030", // 提现-点击修改账户

  ws_log: "99999998", // ws日志
  wsFun_log: "99999999", // ws日志
  gifttask_home_popup: "10450001", // 礼包任务_首页_弹出
  gifttask_jump: "10450002", // 礼包任务_跳转
  gifttask_received: "10450003", // 礼包任务_领取
  threegift_level: "10450004", // 礼包_等级
  threegift_deposit: "10460005", // 三重礼包_充值
};

export default eventkeys;
